var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{attrs:{"prepend-icon":"mdi-calendar","items":_vm.years,"label":_vm.label,"dense":_vm.dense,"clearable":""},on:{"input":_vm.input},model:{value:(_vm.editValue),callback:function ($$v) {_vm.editValue=$$v},expression:"editValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }